import React, { useRef } from 'react';
import Lottie from 'lottie-light-react';
import Button from '../Components/Button';
import { User } from '../Types/User';
import Modal from '../Modal/Modal';
import CreateStudentView from './CreateStudentView';
import animationData from '../animations/no-students.json';

interface NoStudentsViewProps {
  onCreated: (studentUser: User) => void;
}
const NoStudentsView: React.FC<NoStudentsViewProps> = ({ onCreated }) => {
  const [isCreatingStudent, setIsCreatingStudent] = React.useState(false);

  return (
    <>
      <main className="flex overflow-hidden flex-col items-center justify-center h-full">
        <section className="flex flex-col items-center justify-center max-w-full text-center w-[600px] px-8">
          <Lottie
            loop={true}
            autoplay={true}
            animationData={animationData}
            rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
            className="object-contain w-60 max-w-full aspect-square"
          />
          <div className="flex flex-col items-center mt-10 w-full max-md:max-w-full">
            <div className="flex flex-col items-center w-full">
              <h1 className="text-3xl font-bold leading-none text-neutral-800 max-md:max-w-full">
                Create Your Child's Account
              </h1>
              <p className="mt-4 text-base text-neutral-800 text-opacity-70 max-md:max-w-full">
                Get started by creating an account for your child. This will
                allow them to explore and enjoy personalized content tailored to
                their interests and reading level. Add an account now to begin
                the journey!
              </p>
            </div>
            <Button
              testId="open-create-student-modal-button"
              variant="primary"
              className="mt-6"
              onClick={() => {
                setIsCreatingStudent(true);
              }}
            >
              Create Account
            </Button>
          </div>
        </section>
      </main>
      <Modal
        isOpen={isCreatingStudent}
        children={
          <CreateStudentView
            onCreated={onCreated}
            onCancel={() => {
              setIsCreatingStudent(false);
            }}
          />
        }
        maxWidthClass={'max-w-[500px]'}
        onClose={() => setIsCreatingStudent(false)}
      />
    </>
  );
};

export default NoStudentsView;
